import { ACCOUNT_ROLES, ACCOUNT_ROLES_NEW } from '@consts';

import { isValueExist } from '@util';

const { ADMIN, NORMAL } = ACCOUNT_ROLES;
const {
    ADMIN: ADMIN_NEW,
    VIEW_AND_EDIT,
    CONNECTION_MANAGEMENT,
} = ACCOUNT_ROLES_NEW;

const INVOICE_DOWNLOAD = 'INVOICE_DOWNLOAD';
const ACCOUNT_ROLE_CHANGE = 'ACCOUNT_ROLE_CHANGE';
const ACCOUNT_DELETE = 'ACCOUNT_DELETE';
const ACCOUNT_INVITE = 'ACCOUNT_INVITE';
const PAYMENT_DELETE = 'PAYMENT_DELETE';
const PAYMENT_ADD = 'PAYMENT_ADD';
const PAYMENT_SELECT = 'PAYMENT_SELECT';
const ACTION_REQUIRED_FEED_DELETE = 'ACTION_REQUIRED_FEED_DELETE';
const BILLING_HISTORY_BTN_VISIBLE = 'BILLING_HISTORY_BTN_VISIBLE';
const BILLING_HISTORY_PAGE_VISIBLE = 'BILLING_HISTORY_PAGE_VISIBLE';
const CAMPAIGN_DELETABLE = 'CAMPAIGN_DELETABLE';
const BIZ_REG = 'BIZ_REG';
const BIZ_REG_EDITABLE = 'BIZ_REG_EDITABLE';
const CREATE_CAMPAIGN = 'CREATE_CAMPAIGN';
const CONNECTION_NAV_VISIBLE = 'CONNECTION_NAV_VISIBLE';
const PAYMENT_VISIBLE = 'PAYMENT_VISIBLE';
const BIZ_REG_VISIBLE = 'BIZ_REG_VISIBLE';
const PROPOSAL_CONTENT_CLICKABLE = 'PROPOSAL_CONTENT_CLICKABLE';
const CAMPAIGN_LAUNCHABLE = 'CAMPAIGN_LAUNCHABLE';
const MANAGER_ACTION_ITEM_UPDATE = 'MANAGER_ACTION_ITEM_UPDATE';
const CAMPAIGN_BOX_DROPDOWN_VISIBLE = 'CAMPAIGN_BOX_DROPDOWN_VISIBLE';
const DASHBOARD_RUN_LONGER_VISIBLE = 'DASHBOARD_RUN_LONGER_VISIBLE';
const DASHBOARD_ADD_BUDGET_VISIBLE = 'DASHBOARD_ADD_BUDGET_VISIBLE';
const MANAGER_SET_ALARM = 'MANAGER_SET_ALARM';
const ACCOUNT_MODIFIABLE = 'ACCOUNT_MODIFIABLE';
const SESSION_RECORD_BTN_VISIBLE = 'SESSION_RECORD';
const DASHBOARD_PRESET_EDIT = 'DASHBOARD_PRESET_EDIT';
const DASHBOARD_ON_OFF_ACTION = 'DASHBOARD_ON_OFF_ACTION';
const DASHBOARD_CHECKBOX_CLICK = 'DASHBOARD_CHECKBOX_CLICK';
const DASHBOARD_EDIT_ICON_CLICK = 'DASHBOARD_EDIT_ICON_CLICK';
const DASHBOARD_SCHEDULE_BUDGET_EDITABLE = 'DASHBOARD_SCHEDULE_BUDGET_EDITABLE';
const CREDIT_HISTORY_CLICKABLE = 'CREDIT_HISTORY_CLICKABLE';
const ALARM_EDITABLE = 'ALARM_EDITABLE';
const DASHBOARD_VIEW_CREATE = 'DASHBOARD_VIEW_CREATE';
const DASHBOARD_VIEW_RENAME = 'DASHBOARD_VIEW_RENAME';
const DASHBOARD_VIEW_DELETE = 'DASHBOARD_VIEW_DELETE';
const DASHBOARD_WIDGET_RENAME = 'DASHBOARD_WIDGET_RENAME';
const DASHBOARD_VIEW_SORT = 'DASHBOARD_VIEW_SORT';
const DASHBOARD_FOLDER_DROPDOWN = 'DASHBOARD_FOLDER_DROPDOWN';
const DASHBOARD_CUSTOM_METRIC_MANAGE = 'DASHBOARD_CUSTOM_METRIC_MANAGE';
const DASHBOARD_CUSTOM_BREAKDOWN_MANAGE = 'DASHBOARD_CUSTOM_BREAKDOWN_MANAGE';
const COMMENT_WRITE = 'COMMENT_WRITE';
const COMMENT_RESOLVE = 'COMMENT_RESOLVE';
const THREAD_CONTROL = 'THREAD_CONTROL';
const THREAD_DELETE = 'THREAD_DELETE';

const ADMIN_ONLY = new Set([ADMIN, ADMIN_NEW]);
const ADMIN_NORMAL = new Set([ADMIN, NORMAL, ADMIN_NEW, VIEW_AND_EDIT]);
const ADMIN_NORMAL_WITH_CONNECTION = new Set([
    ADMIN,
    NORMAL,
    ADMIN_NEW,
    VIEW_AND_EDIT,
    CONNECTION_MANAGEMENT,
]);

const PERMISSION_MAP = {
    [INVOICE_DOWNLOAD]: ADMIN_ONLY,
    [ACCOUNT_ROLE_CHANGE]: ADMIN_ONLY,
    [ACCOUNT_DELETE]: ADMIN_ONLY,
    [ACCOUNT_INVITE]: ADMIN_ONLY,
    [PAYMENT_DELETE]: ADMIN_ONLY,
    [PAYMENT_ADD]: ADMIN_ONLY,
    [PAYMENT_SELECT]: ADMIN_ONLY,
    [ACTION_REQUIRED_FEED_DELETE]: ADMIN_ONLY,
    [BILLING_HISTORY_BTN_VISIBLE]: ADMIN_ONLY,
    [BILLING_HISTORY_PAGE_VISIBLE]: ADMIN_ONLY,
    [CAMPAIGN_DELETABLE]: ADMIN_ONLY,
    [BIZ_REG]: ADMIN_ONLY,
    [CREATE_CAMPAIGN]: ADMIN_NORMAL,
    [CONNECTION_NAV_VISIBLE]: ADMIN_NORMAL_WITH_CONNECTION,
    [PAYMENT_VISIBLE]: ADMIN_NORMAL,
    [BIZ_REG_VISIBLE]: ADMIN_NORMAL,
    [PROPOSAL_CONTENT_CLICKABLE]: ADMIN_NORMAL,
    [CAMPAIGN_LAUNCHABLE]: ADMIN_NORMAL,
    [MANAGER_ACTION_ITEM_UPDATE]: ADMIN_NORMAL,
    [CAMPAIGN_BOX_DROPDOWN_VISIBLE]: ADMIN_NORMAL,
    [DASHBOARD_RUN_LONGER_VISIBLE]: ADMIN_NORMAL,
    [DASHBOARD_ADD_BUDGET_VISIBLE]: ADMIN_NORMAL,
    [MANAGER_SET_ALARM]: ADMIN_NORMAL,
    [ACCOUNT_MODIFIABLE]: ADMIN_ONLY,
    [SESSION_RECORD_BTN_VISIBLE]: ADMIN_NORMAL,
    [DASHBOARD_PRESET_EDIT]: ADMIN_NORMAL,
    [DASHBOARD_ON_OFF_ACTION]: ADMIN_NORMAL,
    [DASHBOARD_CHECKBOX_CLICK]: ADMIN_NORMAL,
    [DASHBOARD_EDIT_ICON_CLICK]: ADMIN_NORMAL,
    [DASHBOARD_SCHEDULE_BUDGET_EDITABLE]: ADMIN_NORMAL,
    [CREDIT_HISTORY_CLICKABLE]: ADMIN_ONLY,
    [ALARM_EDITABLE]: ADMIN_NORMAL,
    [DASHBOARD_VIEW_CREATE]: ADMIN_NORMAL,
    [DASHBOARD_VIEW_RENAME]: ADMIN_NORMAL,
    [DASHBOARD_VIEW_DELETE]: ADMIN_NORMAL,
    [DASHBOARD_WIDGET_RENAME]: ADMIN_NORMAL,
    [DASHBOARD_VIEW_SORT]: ADMIN_NORMAL,
    [DASHBOARD_FOLDER_DROPDOWN]: ADMIN_NORMAL,
    [DASHBOARD_CUSTOM_METRIC_MANAGE]: ADMIN_NORMAL,
    [DASHBOARD_CUSTOM_BREAKDOWN_MANAGE]: ADMIN_NORMAL,
    [COMMENT_WRITE]: ADMIN_NORMAL,
    [COMMENT_RESOLVE]: ADMIN_NORMAL,
    [THREAD_CONTROL]: ADMIN_NORMAL,
    [THREAD_DELETE]: ADMIN_ONLY,
};

const permissionBy = (key) =>
    R.compose((f) => f(key), R.prop('permission'), R.nthArg(1));

const userIdFromComment = R.path(['user', 'id']);

export default {
    namespaced: true,
    state: getDefaultState(),
    mutations: {},
    actions: {},
    getters: {
        permission:
            (_, _2, rootState, rootGetters) =>
            (key = '') => {
                const isShareMode = rootState['newDashboard/isShareMode'];

                if (isShareMode) {
                    return false;
                }

                const role = rootGetters['user/role'];

                if (
                    role.some((r) => ADMIN_ONLY.has(r)) ||
                    rootGetters['user/isAdmin']
                ) {
                    return true;
                }

                const whiteList = PERMISSION_MAP[key];

                if (!isValueExist(whiteList)) {
                    return true;
                }

                return role.some((r) => whiteList.has(r));
            },
        gteAdmin(_, _2, _3, rootGetters) {
            const role = rootGetters['user/role'];

            if (rootGetters['user/isAdmin']) {
                return true;
            }

            return role.some((r) => ADMIN_ONLY.has(r));
        },
        gteEdit(_, _2, _3, rootGetters) {
            const role = rootGetters['user/role'];

            if (rootGetters['user/isAdmin']) {
                return true;
            }

            return role.some((r) => ADMIN_NORMAL.has(r));
        },
        gteView: R.T,
        accountRoleChangeable: permissionBy(ACCOUNT_ROLE_CHANGE),
        accountDeletable: permissionBy(ACCOUNT_DELETE),
        accountInvitable: permissionBy(ACCOUNT_INVITE),
        // paymentDeletable: permissionBy(PAYMENT_DELETE),
        // paymentAddable: permissionBy(PAYMENT_ADD),
        // paymentSelectable: permissionBy(PAYMENT_SELECT),
        paymentDeletable: R.T,
        paymentAddable: R.T,
        paymentSelectable: R.T,
        actionRequiredFeedDeletable: permissionBy(ACTION_REQUIRED_FEED_DELETE),
        billingHistoryBtnVisible: permissionBy(BILLING_HISTORY_BTN_VISIBLE),
        billingHistoryPageVisible: permissionBy(BILLING_HISTORY_PAGE_VISIBLE),
        campaignDeletable: permissionBy(CAMPAIGN_DELETABLE),
        bizRegVisible(...args) {
            return (
                permissionBy(BIZ_REG_VISIBLE)(...args) &&
                R.converge(R.equals, [
                    R.path(['user/user', 'id']),
                    R.path(['user/account', 'owner_id']),
                ])(args[3])
            );
        },
        bizNoEditable: permissionBy(BIZ_REG_EDITABLE),
        campaignCreatable: permissionBy(CREATE_CAMPAIGN),
        connectionNavVisible: permissionBy(CONNECTION_NAV_VISIBLE),
        // paymentVisible: permissionBy(PAYMENT_VISIBLE),
        paymentVisible: R.T,
        proposalContentClickable: permissionBy(PROPOSAL_CONTENT_CLICKABLE),
        campaignLaunchable: permissionBy(CAMPAIGN_LAUNCHABLE),
        managerActionItemUpdatable: permissionBy(MANAGER_ACTION_ITEM_UPDATE),
        campaignBoxDropdownVisible: permissionBy(CAMPAIGN_BOX_DROPDOWN_VISIBLE),
        dashboardRunLongerVisible: permissionBy(DASHBOARD_RUN_LONGER_VISIBLE),
        dashboardAddBudgetVisible: permissionBy(DASHBOARD_ADD_BUDGET_VISIBLE),
        managerAlarmSettable: permissionBy(MANAGER_SET_ALARM),
        accountModifiable: permissionBy(ACCOUNT_MODIFIABLE),
        sessionRecordBtnVisible: permissionBy(SESSION_RECORD_BTN_VISIBLE),
        dashboardPresetEditable: permissionBy(DASHBOARD_PRESET_EDIT),
        dashboardOnOffPossible: permissionBy(DASHBOARD_ON_OFF_ACTION),
        dashboardEditIconClickable: permissionBy(DASHBOARD_CHECKBOX_CLICK),
        dashboardScheduleBudgetEditable: permissionBy(
            DASHBOARD_SCHEDULE_BUDGET_EDITABLE
        ),
        // creditHistoryClickable: permissionBy(CREDIT_HISTORY_CLICKABLE),
        creditHistoryClickable: R.T,
        alarmEditable: permissionBy(ALARM_EDITABLE),
        dashboardViewCreatable: permissionBy(DASHBOARD_VIEW_CREATE),
        dashboardWidgetRenamable: permissionBy(DASHBOARD_WIDGET_RENAME),
        dashboardViewSortable: permissionBy(DASHBOARD_VIEW_SORT),
        dashboardFolderDropdownClickable: permissionBy(
            DASHBOARD_FOLDER_DROPDOWN
        ),
        dashboardPublicFolderMakable:
            (_, getters) =>
            ({ isViewable }) => {
                const { gteAdmin, gteEdit } = getters;

                return gteAdmin || (isViewable && gteEdit);
            },
        dashboardPrivateFolderMakable:
            (_, getters) =>
            ({ isViewable }) => {
                const { gteAdmin, gteEdit } = getters;

                return gteAdmin || (isViewable && gteEdit);
            },
        ...(() => {
            const _func =
                (_, getters) =>
                ({ isViewable, isPrivate }) => {
                    const { gteAdmin, gteEdit } = getters;

                    return isPrivate
                        ? gteAdmin || (isViewable && gteEdit)
                        : gteEdit;
                };
            return {
                dashboardViewDeletable: _func,
                dashboardViewRenamable: _func,
            };
        })(),
        dashboardCustomMetricManagable: permissionBy(
            DASHBOARD_CUSTOM_METRIC_MANAGE
        ),
        dashboardCustomBreakdownManagable: permissionBy(
            DASHBOARD_CUSTOM_BREAKDOWN_MANAGE
        ),
        commentWritable: permissionBy(COMMENT_WRITE),
        commentEditable:
            (_, getters, _2, rootGetters) =>
            ({ comment }) => {
                return userIdFromComment(comment) == rootGetters['user/userId'];
            },
        commentDeletable:
            (_, getters, _2, rootGetters) =>
            ({ comment }) => {
                const { gteAdmin } = getters;

                return (
                    gteAdmin ||
                    userIdFromComment(comment) == rootGetters['user/userId']
                );
            },
        commentResolvable: permissionBy(COMMENT_RESOLVE),
        threadControllable: permissionBy(THREAD_CONTROL),
        threadDeletable: permissionBy(THREAD_DELETE),
    },
};

function getDefaultState() {
    return {};
}
